// Envío seguro de eventos a Google Analytics 4 (gtag.js se carga en public/index.html).
// Nunca debe romper la app: si gtag no está disponible (bloqueadores, cargas fallidas), no hace nada.

type GtagParams = Record<string, any>;

export const trackEvent = (name: string, params: GtagParams = {}) => {
  try {
    const g = (window as any).gtag;
    if (typeof g === "function") {
      g("event", name, params);
    }
  } catch (e) {
    // Analytics nunca debe interrumpir el flujo del usuario.
  }
};

// Convierte importes en string ("40.00") a número para el parámetro `value` de GA4.
export const toValue = (v: unknown): number => {
  const n = typeof v === "string" ? parseFloat(v.replace(",", ".")) : Number(v);
  return Number.isFinite(n) ? n : 0;
};
